//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./crm.d.ts" />

import * as $ from "skir-client";

// -----------------------------------------------------------------------------
// enum CrmProvider
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CrmProvider extends $._EnumBase {}

function createValueOfCrmProvider(initializer) {
  const { kind, value } = initializer;
  switch (kind) {
    case "other": {
      return value;
    }
  }
}

// -----------------------------------------------------------------------------
// enum CrmSyncStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CrmSyncStatus extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum DescriptionMode
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class DescriptionMode extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum CustomFieldWriteMode
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CustomFieldWriteMode extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum CrmDataSource
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CrmDataSource extends $._EnumBase {}

function createValueOfCrmDataSource(initializer) {
  const { kind, value } = initializer;
  switch (kind) {
    case "other": {
      return value;
    }
  }
}

// -----------------------------------------------------------------------------
// enum CrmInferredFrom
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CrmInferredFrom extends $._EnumBase {}

function createValueOfCrmInferredFrom(initializer) {
  const { kind, value } = initializer;
  switch (kind) {
    case "other": {
      return value;
    }
  }
}

// -----------------------------------------------------------------------------
// enum CrmMatchingMethod
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CrmMatchingMethod extends $._EnumBase {}

function createValueOfCrmMatchingMethod(initializer) {
  const { kind, value } = initializer;
  switch (kind) {
    case "other": {
      return value;
    }
  }
}

// -----------------------------------------------------------------------------
// enum CrmMatchAcceptanceMethod
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CrmMatchAcceptanceMethod extends $._EnumBase {}

function createValueOfCrmMatchAcceptanceMethod(initializer) {
  const { kind, value } = initializer;
  switch (kind) {
    case "other": {
      return value;
    }
  }
}

// -----------------------------------------------------------------------------
// struct CrmMergeConnection
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmMergeConnection.Mutable`. */
export class CrmMergeConnection extends $._FrozenBase {}

function initCrmMergeConnection(target, initializer) {
  target.accountToken = initializer.accountToken ?? "";
  target.providerName = initializer.providerName ?? "";
}

// -----------------------------------------------------------------------------
// struct CrmHubspotConnection
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmHubspotConnection.Mutable`. */
export class CrmHubspotConnection extends $._FrozenBase {}

function initCrmHubspotConnection(target, initializer) {
  target.portalId = initializer.portalId ?? "";
  target.datacenter = initializer.datacenter ?? "";
  target.accessToken = initializer.accessToken ?? "";
  target.refreshToken = initializer.refreshToken ?? "";
}

// -----------------------------------------------------------------------------
// struct CrmAttioConnection
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmAttioConnection.Mutable`. */
export class CrmAttioConnection extends $._FrozenBase {}

function initCrmAttioConnection(target, initializer) {
  target.accessToken = initializer.accessToken ?? "";
  target.workspaceSlug = initializer.workspaceSlug ?? "";
  target.webhookId = initializer.webhookId ?? "";
  target.webhookSecret = initializer.webhookSecret ?? "";
}

// -----------------------------------------------------------------------------
// struct CrmSalesforceConnection
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmSalesforceConnection.Mutable`. */
export class CrmSalesforceConnection extends $._FrozenBase {}

function initCrmSalesforceConnection(target, initializer) {
  target.accessToken = initializer.accessToken ?? "";
  target.refreshToken = initializer.refreshToken ?? "";
  target.instanceUrl = initializer.instanceUrl ?? "";
  target.orgId = initializer.orgId ?? "";
}

// -----------------------------------------------------------------------------
// enum CrmConnection
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CrmConnection extends $._EnumBase {}

function createValueOfCrmConnection(initializer) {
  const { kind, value } = initializer;
  switch (kind) {
    case "merge": {
      return CrmMergeConnection.create(value);
    }
    case "hubspot": {
      return CrmHubspotConnection.create(value);
    }
    case "attio": {
      return CrmAttioConnection.create(value);
    }
    case "salesforce": {
      return CrmSalesforceConnection.create(value);
    }
  }
}

// -----------------------------------------------------------------------------
// struct CrmEntity
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmEntity.Mutable`. */
export class CrmEntity extends $._FrozenBase {}

function initCrmEntity(target, initializer) {
  target.remoteId = initializer.remoteId ?? "";
  target.mergeId = initializer.mergeId ?? "";
  target.lastSync = initializer.lastSync ?? $.Timestamp.UNIX_EPOCH;
  target.crmProvider = initializer.crmProvider ?? "";
  target.providerType = initializer.providerType ? CrmProvider.create(initializer.providerType) : null;
  target.deletedAt = initializer.deletedAt ?? null;
  target.webUrl = initializer.webUrl ?? "";
}

// -----------------------------------------------------------------------------
// struct ExternalCrmAccount.Address
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `ExternalCrmAccount.Address.Mutable`.
 *
 * @alias ExternalCrmAccount.Address
 */
class ExternalCrmAccount_Address extends $._FrozenBase {}

function initExternalCrmAccount_Address(target, initializer) {
  target.street = initializer.street ?? "";
  target.city = initializer.city ?? "";
  target.state = initializer.state ?? "";
  target.postalCode = initializer.postalCode ?? "";
  target.country = initializer.country ?? "";
}

// -----------------------------------------------------------------------------
// struct ExternalCrmAccount
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ExternalCrmAccount.Mutable`. */
export class ExternalCrmAccount extends $._FrozenBase {}

function initExternalCrmAccount(target, initializer) {
  target.base = CrmEntity.create(initializer.base ?? CrmEntity.DEFAULT);
  target.name = initializer.name ?? "";
  target.description = initializer.description ?? "";
  target.industry = initializer.industry ?? "";
  target.website = initializer.website ?? "";
  target.billingAddress = initializer.billingAddress ? ExternalCrmAccount_Address.create(initializer.billingAddress) : null;
  target.accountType = initializer.accountType ?? "";
  target.annualRevenue = initializer.annualRevenue ?? null;
  target.numberOfEmployees = initializer.numberOfEmployees ?? null;
  target.ownerName = initializer.ownerName ?? "";
  target.ownerEmail = initializer.ownerEmail ?? "";
}

// -----------------------------------------------------------------------------
// struct ExternalCrmContact
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ExternalCrmContact.Mutable`. */
export class ExternalCrmContact extends $._FrozenBase {}

function initExternalCrmContact(target, initializer) {
  target.base = CrmEntity.create(initializer.base ?? CrmEntity.DEFAULT);
  target.firstName = initializer.firstName ?? "";
  target.lastName = initializer.lastName ?? "";
  target.email = initializer.email ?? "";
  target.phone = initializer.phone ?? "";
  target.jobTitle = initializer.jobTitle ?? "";
  target.accountId = initializer.accountId ?? "";
  target.accountName = initializer.accountName ?? "";
  target.leadSource = initializer.leadSource ?? "";
  target.contactStage = initializer.contactStage ?? "";
  target.linkedinUrl = initializer.linkedinUrl ?? "";
  target.notes = initializer.notes ?? "";
  target.lastActivityAt = initializer.lastActivityAt ?? null;
  target.ownerName = initializer.ownerName ?? "";
  target.ownerEmail = initializer.ownerEmail ?? "";
}

// -----------------------------------------------------------------------------
// enum ExternalCrmEngagement.EngagementType
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias ExternalCrmEngagement.EngagementType
 */
class ExternalCrmEngagement_EngagementType extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum ExternalCrmEngagement.Direction
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias ExternalCrmEngagement.Direction
 */
class ExternalCrmEngagement_Direction extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct ExternalCrmEngagement
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ExternalCrmEngagement.Mutable`. */
export class ExternalCrmEngagement extends $._FrozenBase {}

function initExternalCrmEngagement(target, initializer) {
  target.base = CrmEntity.create(initializer.base ?? CrmEntity.DEFAULT);
  target.subject = initializer.subject ?? "";
  target.content = initializer.content ?? "";
  target.engagementType = ExternalCrmEngagement_EngagementType.create(initializer.engagementType ?? ExternalCrmEngagement_EngagementType.UNKNOWN);
  target.direction = initializer.direction ? ExternalCrmEngagement_Direction.create(initializer.direction) : null;
  target.startTime = initializer.startTime ?? null;
  target.endTime = initializer.endTime ?? null;
  target.accountId = initializer.accountId ?? "";
  target.contactIds = $._toFrozenArray(
    initializer.contactIds || []);
    target.ownerName = initializer.ownerName ?? "";
    target.ownerEmail = initializer.ownerEmail ?? "";
    target.createdAt = initializer.createdAt ?? $.Timestamp.UNIX_EPOCH;
    target.modifiedAt = initializer.modifiedAt ?? $.Timestamp.UNIX_EPOCH;
    target.matchedViaEmail = initializer.matchedViaEmail ?? "";
}

// -----------------------------------------------------------------------------
// struct ExternalCrmDealStage
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ExternalCrmDealStage.Mutable`. */
export class ExternalCrmDealStage extends $._FrozenBase {}

function initExternalCrmDealStage(target, initializer) {
  target.id = initializer.id ?? "";
  target.name = initializer.name ?? "";
  target.displayOrder = initializer.displayOrder ?? 0;
  target.probability = initializer.probability ?? null;
  target.isClosedWon = initializer.isClosedWon ?? false;
  target.isClosedLost = initializer.isClosedLost ?? false;
}

// -----------------------------------------------------------------------------
// struct ExternalCrmPipeline
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ExternalCrmPipeline.Mutable`. */
export class ExternalCrmPipeline extends $._FrozenBase {}

function initExternalCrmPipeline(target, initializer) {
  target.id = initializer.id ?? "";
  target.name = initializer.name ?? "";
  target.stages = $._toFrozenArray(
    initializer.stages || [],
    ExternalCrmDealStage.create,
  );
}

// -----------------------------------------------------------------------------
// enum ExternalCrmOpportunity.Status
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias ExternalCrmOpportunity.Status
 */
class ExternalCrmOpportunity_Status extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct ExternalCrmOpportunity
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ExternalCrmOpportunity.Mutable`. */
export class ExternalCrmOpportunity extends $._FrozenBase {}

function initExternalCrmOpportunity(target, initializer) {
  target.base = CrmEntity.create(initializer.base ?? CrmEntity.DEFAULT);
  target.name = initializer.name ?? "";
  target.description = initializer.description ?? "";
  target.amount = initializer.amount ?? null;
  target.currency = initializer.currency ?? "";
  target.stage = initializer.stage ?? "";
  target.probability = initializer.probability ?? null;
  target.expectedCloseDate = initializer.expectedCloseDate ?? null;
  target.createdDate = initializer.createdDate ?? $.Timestamp.UNIX_EPOCH;
  target.accountId = initializer.accountId ?? "";
  target.accountName = initializer.accountName ?? "";
  target.primaryContactId = initializer.primaryContactId ?? "";
  target.ownerName = initializer.ownerName ?? "";
  target.ownerEmail = initializer.ownerEmail ?? "";
  target.leadSource = initializer.leadSource ?? "";
  target.nextAction = initializer.nextAction ?? "";
  target.nextActionDate = initializer.nextActionDate ?? null;
  target.dealType = initializer.dealType ?? "";
  target.status = ExternalCrmOpportunity_Status.create(initializer.status ?? ExternalCrmOpportunity_Status.UNKNOWN);
  target.pipelineId = initializer.pipelineId ?? "";
  target.contactIds = $._toFrozenArray(
    initializer.contactIds || []);
    target.stageId = initializer.stageId ?? "";
    target.closedAt = initializer.closedAt ?? null;
}

// -----------------------------------------------------------------------------
// enum MeetingCrmLink.LinkType
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias MeetingCrmLink.LinkType
 */
class MeetingCrmLink_LinkType extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct MeetingCrmLink.MatchingCriteria
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `MeetingCrmLink.MatchingCriteria.Mutable`.
 *
 * @alias MeetingCrmLink.MatchingCriteria
 */
class MeetingCrmLink_MatchingCriteria extends $._FrozenBase {}

function initMeetingCrmLink_MatchingCriteria(target, initializer) {
  target.matchedByEmail = initializer.matchedByEmail ?? false;
  target.matchedByCalendarTitle = initializer.matchedByCalendarTitle ?? false;
  target.matchedByParticipantDomain = initializer.matchedByParticipantDomain ?? false;
  target.matchedByExistingOpportunity = initializer.matchedByExistingOpportunity ?? false;
  target.customMatchingRules = $._toFrozenArray(
    initializer.customMatchingRules || []);
}

// -----------------------------------------------------------------------------
// struct MeetingCrmLink
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MeetingCrmLink.Mutable`. */
export class MeetingCrmLink extends $._FrozenBase {}

function initMeetingCrmLink(target, initializer) {
  target.meetingId = initializer.meetingId ?? "";
  target.userId = initializer.userId ?? "";
  target.opportunityIds = $._toFrozenArray(
    initializer.opportunityIds || []);
    target.contactIds = $._toFrozenArray(
      initializer.contactIds || []);
      target.accountIds = $._toFrozenArray(
        initializer.accountIds || []);
        target.linkType = MeetingCrmLink_LinkType.create(initializer.linkType ?? MeetingCrmLink_LinkType.UNKNOWN);
        target.confidenceScore = initializer.confidenceScore ?? null;
        target.matchingCriteria = initializer.matchingCriteria ? MeetingCrmLink_MatchingCriteria.create(initializer.matchingCriteria) : null;
        target.linkedAt = initializer.linkedAt ?? $.Timestamp.UNIX_EPOCH;
        target.lastUpdated = initializer.lastUpdated ?? $.Timestamp.UNIX_EPOCH;
        target.linkedByUserId = initializer.linkedByUserId ?? null;
        target.notes = initializer.notes ?? "";
}

// -----------------------------------------------------------------------------
// struct CrmIntegration.MatchingPreferences
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CrmIntegration.MatchingPreferences.Mutable`.
 *
 * @alias CrmIntegration.MatchingPreferences
 */
class CrmIntegration_MatchingPreferences extends $._FrozenBase {}

function initCrmIntegration_MatchingPreferences(target, initializer) {
  target.matchByEmail = initializer.matchByEmail ?? false;
  target.matchByDomain = initializer.matchByDomain ?? false;
  target.matchByCalendarKeywords = initializer.matchByCalendarKeywords ?? false;
  target.minimumConfidenceThreshold = initializer.minimumConfidenceThreshold ?? 0;
  target.autoLinkHighConfidence = initializer.autoLinkHighConfidence ?? false;
}

// -----------------------------------------------------------------------------
// struct CrmIntegration.CrmSyncSettings.ContactSettings
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CrmIntegration.CrmSyncSettings.ContactSettings.Mutable`.
 *
 * @alias CrmIntegration.CrmSyncSettings.ContactSettings
 */
class CrmIntegration_CrmSyncSettings_ContactSettings extends $._FrozenBase {}

function initCrmIntegration_CrmSyncSettings_ContactSettings(target, initializer) {
  target.enabled = initializer.enabled ?? false;
  target.autoCreate = initializer.autoCreate ?? false;
  target.createCallNote = initializer.createCallNote ?? false;
  target.syncLastContacted = initializer.syncLastContacted ?? false;
}

// -----------------------------------------------------------------------------
// struct CrmIntegration.CrmSyncSettings.AccountSettings
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CrmIntegration.CrmSyncSettings.AccountSettings.Mutable`.
 *
 * @alias CrmIntegration.CrmSyncSettings.AccountSettings
 */
class CrmIntegration_CrmSyncSettings_AccountSettings extends $._FrozenBase {}

function initCrmIntegration_CrmSyncSettings_AccountSettings(target, initializer) {
  target.enabled = initializer.enabled ?? false;
  target.autoCreate = initializer.autoCreate ?? false;
  target.syncDescription = initializer.syncDescription ?? false;
  target.syncLastInteraction = initializer.syncLastInteraction ?? false;
  target.descriptionMode = initializer.descriptionMode ?? "";
  target.descriptionModeType = initializer.descriptionModeType ? DescriptionMode.create(initializer.descriptionModeType) : null;
}

// -----------------------------------------------------------------------------
// struct CrmIntegration.CrmSyncSettings.CustomFieldSyncSetting
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CrmIntegration.CrmSyncSettings.CustomFieldSyncSetting.Mutable`.
 *
 * @alias CrmIntegration.CrmSyncSettings.CustomFieldSyncSetting
 */
class CrmIntegration_CrmSyncSettings_CustomFieldSyncSetting extends $._FrozenBase {}

function initCrmIntegration_CrmSyncSettings_CustomFieldSyncSetting(target, initializer) {
  target.apiSlug = initializer.apiSlug ?? "";
  target.enabled = initializer.enabled ?? false;
  target.mode = CustomFieldWriteMode.create(initializer.mode ?? CustomFieldWriteMode.UNKNOWN);
  target.instructions = initializer.instructions ?? "";
}

// -----------------------------------------------------------------------------
// struct CrmIntegration.CrmSyncSettings
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CrmIntegration.CrmSyncSettings.Mutable`.
 *
 * @alias CrmIntegration.CrmSyncSettings
 */
class CrmIntegration_CrmSyncSettings extends $._FrozenBase {}

function initCrmIntegration_CrmSyncSettings(target, initializer) {
  target.contacts = CrmIntegration_CrmSyncSettings_ContactSettings.create(initializer.contacts ?? CrmIntegration_CrmSyncSettings_ContactSettings.DEFAULT);
  target.accounts = initializer.accounts ? CrmIntegration_CrmSyncSettings_AccountSettings.create(initializer.accounts) : null;
  target.opportunityCustomFields = initializer.opportunityCustomFields ? $._toFrozenArray(
    initializer.opportunityCustomFields,
    CrmIntegration_CrmSyncSettings_CustomFieldSyncSetting.create,
  ) : null;
  target.contactCustomFields = initializer.contactCustomFields ? $._toFrozenArray(
    initializer.contactCustomFields,
    CrmIntegration_CrmSyncSettings_CustomFieldSyncSetting.create,
  ) : null;
  target.accountCustomFields = initializer.accountCustomFields ? $._toFrozenArray(
    initializer.accountCustomFields,
    CrmIntegration_CrmSyncSettings_CustomFieldSyncSetting.create,
  ) : null;
}

// -----------------------------------------------------------------------------
// struct CrmIntegration
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmIntegration.Mutable`. */
export class CrmIntegration extends $._FrozenBase {}

function initCrmIntegration(target, initializer) {
  target.accountId = initializer.accountId ?? BigInt(0);
  target.oauthState = initializer.oauthState ?? "";
  target.mergeAccountToken = initializer.mergeAccountToken ?? "";
  target.oauthConnectedAt = initializer.oauthConnectedAt ?? null;
  target.oauthExpiresAt = initializer.oauthExpiresAt ?? null;
  target.crmProvider = initializer.crmProvider ?? "";
  target.crmInstanceUrl = initializer.crmInstanceUrl ?? "";
  target.crmUserEmail = initializer.crmUserEmail ?? null;
  target.autoMatchingEnabled = initializer.autoMatchingEnabled ?? false;
  target.syncFrequencyHours = initializer.syncFrequencyHours ?? 0;
  target.lastSync = initializer.lastSync ?? $.Timestamp.UNIX_EPOCH;
  target.syncStatus = initializer.syncStatus ?? "";
  target.syncErrorMessage = initializer.syncErrorMessage ?? null;
  target.matchingPreferences = CrmIntegration_MatchingPreferences.create(initializer.matchingPreferences ?? CrmIntegration_MatchingPreferences.DEFAULT);
  target.enabledAt = initializer.enabledAt ?? $.Timestamp.UNIX_EPOCH;
  target.enabledByUserId = initializer.enabledByUserId ?? "";
  target.hubspotPortalId = initializer.hubspotPortalId ?? null;
  target.hubspotDatacenter = initializer.hubspotDatacenter ?? null;
  target.syncSettings = initializer.syncSettings ? CrmIntegration_CrmSyncSettings.create(initializer.syncSettings) : null;
  target.connectorType = initializer.connectorType ?? "";
  target.hubspotAccessToken = initializer.hubspotAccessToken ?? null;
  target.hubspotRefreshToken = initializer.hubspotRefreshToken ?? null;
  target.attioAccessToken = initializer.attioAccessToken ?? null;
  target.attioWorkspaceSlug = initializer.attioWorkspaceSlug ?? null;
  target.salesforceAccessToken = initializer.salesforceAccessToken ?? null;
  target.salesforceRefreshToken = initializer.salesforceRefreshToken ?? null;
  target.salesforceInstanceUrl = initializer.salesforceInstanceUrl ?? null;
  target.salesforceOrgId = initializer.salesforceOrgId ?? null;
  target.attioWebhookId = initializer.attioWebhookId ?? null;
  target.attioWebhookSecret = initializer.attioWebhookSecret ?? null;
  target.connection = initializer.connection ? CrmConnection.create(initializer.connection) : null;
  target.syncStatusType = initializer.syncStatusType ? CrmSyncStatus.create(initializer.syncStatusType) : null;
  target.crmWriteAccess = initializer.crmWriteAccess ?? null;
}

// -----------------------------------------------------------------------------
// struct CrmMatchingLog
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmMatchingLog.Mutable`. */
export class CrmMatchingLog extends $._FrozenBase {}

function initCrmMatchingLog(target, initializer) {
  target.id = initializer.id ?? "";
  target.meetingId = initializer.meetingId ?? "";
  target.userId = initializer.userId ?? "";
  target.accountId = initializer.accountId ?? BigInt(0);
  target.attemptedAt = initializer.attemptedAt ?? $.Timestamp.UNIX_EPOCH;
  target.matchingMethod = initializer.matchingMethod ?? "";
  target.opportunitiesFound = initializer.opportunitiesFound ?? 0;
  target.contactsFound = initializer.contactsFound ?? 0;
  target.accountsFound = initializer.accountsFound ?? 0;
  target.bestMatchOpportunityId = initializer.bestMatchOpportunityId ?? null;
  target.bestMatchConfidence = initializer.bestMatchConfidence ?? null;
  target.criteriaUsed = $._toFrozenArray(
    initializer.criteriaUsed || []);
    target.matchAccepted = initializer.matchAccepted ?? false;
    target.matchAcceptanceMethod = initializer.matchAcceptanceMethod ?? "";
    target.errorMessage = initializer.errorMessage ?? null;
    target.matchingDurationMs = initializer.matchingDurationMs ?? 0;
    target.matchingMethodType = initializer.matchingMethodType ? CrmMatchingMethod.create(initializer.matchingMethodType) : null;
    target.matchAcceptanceMethodType = initializer.matchAcceptanceMethodType ? CrmMatchAcceptanceMethod.create(initializer.matchAcceptanceMethodType) : null;
}

// -----------------------------------------------------------------------------
// struct CrmDataCache
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmDataCache.Mutable`. */
export class CrmDataCache extends $._FrozenBase {}

function initCrmDataCache(target, initializer) {
  target.accountId = initializer.accountId ?? BigInt(0);
  target.opportunities = $._toFrozenArray(
    initializer.opportunities || [],
    ExternalCrmOpportunity.create,
  );
  target.contacts = $._toFrozenArray(
    initializer.contacts || [],
    ExternalCrmContact.create,
  );
  target.accounts = $._toFrozenArray(
    initializer.accounts || [],
    ExternalCrmAccount.create,
  );
  target.lastUpdated = initializer.lastUpdated ?? $.Timestamp.UNIX_EPOCH;
  target.cacheVersion = initializer.cacheVersion ?? "";
  target.totalOpportunities = initializer.totalOpportunities ?? 0;
  target.totalContacts = initializer.totalContacts ?? 0;
  target.totalAccounts = initializer.totalAccounts ?? 0;
}

// -----------------------------------------------------------------------------
// enum CrmAccount.AccountType
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias CrmAccount.AccountType
 */
class CrmAccount_AccountType extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct CrmAccount
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmAccount.Mutable`. */
export class CrmAccount extends $._FrozenBase {}

function initCrmAccount(target, initializer) {
  target.id = initializer.id ?? null;
  target.accountId = initializer.accountId ?? BigInt(0);
  target.name = initializer.name ?? "";
  target.domain = initializer.domain ?? "";
  target.additionalDomains = $._toFrozenArray(
    initializer.additionalDomains || []);
    target.industry = initializer.industry ?? "";
    target.description = initializer.description ?? "";
    target.website = initializer.website ?? "";
    target.totalContacts = initializer.totalContacts ?? 0;
    target.totalMeetings = initializer.totalMeetings ?? 0;
    target.firstInteraction = initializer.firstInteraction ?? null;
    target.lastInteraction = initializer.lastInteraction ?? null;
    target.accountType = CrmAccount_AccountType.create(initializer.accountType ?? CrmAccount_AccountType.UNKNOWN);
    target.createdAt = initializer.createdAt ?? $.Timestamp.UNIX_EPOCH;
    target.updatedAt = initializer.updatedAt ?? $.Timestamp.UNIX_EPOCH;
    target.confidenceScore = initializer.confidenceScore ?? 0;
    target.dataSource = initializer.dataSource ?? "";
    target.externalCrm = initializer.externalCrm ? CrmEntity.create(initializer.externalCrm) : null;
    target.externalCrmPermalink = initializer.externalCrmPermalink ?? null;
    target.ownerName = initializer.ownerName ?? "";
    target.ownerEmail = initializer.ownerEmail ?? "";
    target.ownerUserId = initializer.ownerUserId ?? "";
    target.dataSourceType = initializer.dataSourceType ? CrmDataSource.create(initializer.dataSourceType) : null;
}

// -----------------------------------------------------------------------------
// enum CrmOpportunity.Stage
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias CrmOpportunity.Stage
 */
class CrmOpportunity_Stage extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct CrmOpportunity
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmOpportunity.Mutable`. */
export class CrmOpportunity extends $._FrozenBase {}

function initCrmOpportunity(target, initializer) {
  target.id = initializer.id ?? null;
  target.accountId = initializer.accountId ?? BigInt(0);
  target.name = initializer.name ?? "";
  target.description = initializer.description ?? "";
  target.crmAccountId = initializer.crmAccountId ?? null;
  target.accountName = initializer.accountName ?? "";
  target.primaryContactIds = $._toFrozenArray(
    initializer.primaryContactIds || []);
    target.estimatedValue = initializer.estimatedValue ?? null;
    target.currency = initializer.currency ?? "";
    target.stage = CrmOpportunity_Stage.create(initializer.stage ?? CrmOpportunity_Stage.UNKNOWN);
    target.expectedCloseDate = initializer.expectedCloseDate ?? null;
    target.probability = initializer.probability ?? null;
    target.totalMeetings = initializer.totalMeetings ?? 0;
    target.lastMeetingDate = initializer.lastMeetingDate ?? null;
    target.createdAt = initializer.createdAt ?? $.Timestamp.UNIX_EPOCH;
    target.updatedAt = initializer.updatedAt ?? $.Timestamp.UNIX_EPOCH;
    target.confidenceScore = initializer.confidenceScore ?? 0;
    target.inferredFrom = initializer.inferredFrom ?? "";
    target.externalCrm = initializer.externalCrm ? CrmEntity.create(initializer.externalCrm) : null;
    target.externalCrmPermalink = initializer.externalCrmPermalink ?? null;
    target.stageName = initializer.stageName ?? "";
    target.pipelineId = initializer.pipelineId ?? "";
    target.stageId = initializer.stageId ?? "";
    target.stageDisplayOrder = initializer.stageDisplayOrder ?? 0;
    target.stageIsClosed = initializer.stageIsClosed ?? false;
    target.accountDomain = initializer.accountDomain ?? "";
    target.stageIsClosedWon = initializer.stageIsClosedWon ?? false;
    target.stageIsClosedLost = initializer.stageIsClosedLost ?? false;
    target.ownerName = initializer.ownerName ?? "";
    target.ownerEmail = initializer.ownerEmail ?? "";
    target.ownerUserId = initializer.ownerUserId ?? "";
    target.inferredFromType = initializer.inferredFromType ? CrmInferredFrom.create(initializer.inferredFromType) : null;
    target.closedAt = initializer.closedAt ?? null;
}

// -----------------------------------------------------------------------------
// enum CrmOpportunityStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CrmOpportunityStatus extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct TimeRange
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `TimeRange.Mutable`. */
export class TimeRange extends $._FrozenBase {}

function initTimeRange(target, initializer) {
  target.start = initializer.start ?? null;
  target.end = initializer.end ?? null;
}

// -----------------------------------------------------------------------------
// struct CrmOpportunityFilter
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmOpportunityFilter.Mutable`. */
export class CrmOpportunityFilter extends $._FrozenBase {}

function initCrmOpportunityFilter(target, initializer) {
  target.searchQuery_ = initializer.searchQuery_ ?? "";
  target.pipelineIds = $._toFrozenArray(
    initializer.pipelineIds || []);
    target.excludedPipelineIds = $._toFrozenArray(
      initializer.excludedPipelineIds || []);
      target.stageIds = $._toFrozenArray(
        initializer.stageIds || []);
        target.stages = $._toFrozenArray(
          initializer.stages || [],
          CrmOpportunity_Stage.create,
        );
        target.statuses = $._toFrozenArray(
          initializer.statuses || [],
          CrmOpportunityStatus.create,
        );
        target.ownerEmails = $._toFrozenArray(
          initializer.ownerEmails || []);
          target.ownerUserIds = $._toFrozenArray(
            initializer.ownerUserIds || []);
            target.expectedClose = initializer.expectedClose ? TimeRange.create(initializer.expectedClose) : null;
}

// -----------------------------------------------------------------------------
// struct CrmOpportunityFacets.StatusCount
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CrmOpportunityFacets.StatusCount.Mutable`.
 *
 * @alias CrmOpportunityFacets.StatusCount
 */
class CrmOpportunityFacets_StatusCount extends $._FrozenBase {}

function initCrmOpportunityFacets_StatusCount(target, initializer) {
  target.status = CrmOpportunityStatus.create(initializer.status ?? CrmOpportunityStatus.UNKNOWN);
  target.count = initializer.count ?? 0;
}

// -----------------------------------------------------------------------------
// struct CrmOpportunityFacets.PipelineCount
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CrmOpportunityFacets.PipelineCount.Mutable`.
 *
 * @alias CrmOpportunityFacets.PipelineCount
 */
class CrmOpportunityFacets_PipelineCount extends $._FrozenBase {}

function initCrmOpportunityFacets_PipelineCount(target, initializer) {
  target.pipelineId = initializer.pipelineId ?? "";
  target.count = initializer.count ?? 0;
}

// -----------------------------------------------------------------------------
// struct CrmOpportunityFacets.StageCount
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CrmOpportunityFacets.StageCount.Mutable`.
 *
 * @alias CrmOpportunityFacets.StageCount
 */
class CrmOpportunityFacets_StageCount extends $._FrozenBase {}

function initCrmOpportunityFacets_StageCount(target, initializer) {
  target.pipelineId = initializer.pipelineId ?? "";
  target.stageId = initializer.stageId ?? "";
  target.stage = CrmOpportunity_Stage.create(initializer.stage ?? CrmOpportunity_Stage.UNKNOWN);
  target.stageName = initializer.stageName ?? "";
  target.displayOrder = initializer.displayOrder ?? 0;
  target.status = CrmOpportunityStatus.create(initializer.status ?? CrmOpportunityStatus.UNKNOWN);
  target.count = initializer.count ?? 0;
}

// -----------------------------------------------------------------------------
// struct CrmOpportunityFacets.OwnerCount
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CrmOpportunityFacets.OwnerCount.Mutable`.
 *
 * @alias CrmOpportunityFacets.OwnerCount
 */
class CrmOpportunityFacets_OwnerCount extends $._FrozenBase {}

function initCrmOpportunityFacets_OwnerCount(target, initializer) {
  target.ownerEmail = initializer.ownerEmail ?? "";
  target.ownerName = initializer.ownerName ?? "";
  target.ownerUserId = initializer.ownerUserId ?? "";
  target.count = initializer.count ?? 0;
}

// -----------------------------------------------------------------------------
// struct CrmOpportunityFacets
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmOpportunityFacets.Mutable`. */
export class CrmOpportunityFacets extends $._FrozenBase {}

function initCrmOpportunityFacets(target, initializer) {
  target.totalCount = initializer.totalCount ?? 0;
  target.statuses = $._toFrozenArray(
    initializer.statuses || [],
    CrmOpportunityFacets_StatusCount.create,
  );
  target.pipelines = $._toFrozenArray(
    initializer.pipelines || [],
    CrmOpportunityFacets_PipelineCount.create,
  );
  target.stages = $._toFrozenArray(
    initializer.stages || [],
    CrmOpportunityFacets_StageCount.create,
  );
  target.owners = $._toFrozenArray(
    initializer.owners || [],
    CrmOpportunityFacets_OwnerCount.create,
  );
}

// -----------------------------------------------------------------------------
// enum CrmObjectType
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class CrmObjectType extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct ExternalCrmField
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ExternalCrmField.Mutable`. */
export class ExternalCrmField extends $._FrozenBase {}

function initExternalCrmField(target, initializer) {
  target.id = initializer.id ?? "";
  target.apiSlug = initializer.apiSlug ?? "";
  target.name = initializer.name ?? "";
  target.type = initializer.type ?? "";
  target.isWritable = initializer.isWritable ?? false;
  target.description = initializer.description ?? "";
  target.choices = $._toFrozenArray(
    initializer.choices || []);
}

// -----------------------------------------------------------------------------
// struct CrmOpportunityWindowStats
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmOpportunityWindowStats.Mutable`. */
export class CrmOpportunityWindowStats extends $._FrozenBase {}

function initCrmOpportunityWindowStats(target, initializer) {
  target.startDate = initializer.startDate ?? "";
  target.endDate = initializer.endDate ?? "";
  target.created = initializer.created ?? 0;
  target.createdValue = initializer.createdValue ?? 0;
  target.won = initializer.won ?? 0;
  target.lost = initializer.lost ?? 0;
  target.open = initializer.open ?? 0;
}

// -----------------------------------------------------------------------------
// struct CrmOwnerOpportunityStats
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmOwnerOpportunityStats.Mutable`. */
export class CrmOwnerOpportunityStats extends $._FrozenBase {}

function initCrmOwnerOpportunityStats(target, initializer) {
  target.ownerEmail = initializer.ownerEmail ?? "";
  target.created = initializer.created ?? 0;
  target.won = initializer.won ?? 0;
  target.lost = initializer.lost ?? 0;
  target.open = initializer.open ?? 0;
}

// -----------------------------------------------------------------------------
// struct CrmPipelineAnalytics
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmPipelineAnalytics.Mutable`. */
export class CrmPipelineAnalytics extends $._FrozenBase {}

function initCrmPipelineAnalytics(target, initializer) {
  target.startDate = initializer.startDate ?? "";
  target.endDate = initializer.endDate ?? "";
  target.asOf = initializer.asOf ?? "";
  target.totalDeals = initializer.totalDeals ?? 0;
  target.openDeals = initializer.openDeals ?? 0;
  target.wonDeals = initializer.wonDeals ?? 0;
  target.lostDeals = initializer.lostDeals ?? 0;
  target.openValue = initializer.openValue ?? 0;
  target.wonValue = initializer.wonValue ?? 0;
  target.closeRate = initializer.closeRate ?? null;
  target.window = CrmOpportunityWindowStats.create(initializer.window ?? CrmOpportunityWindowStats.DEFAULT);
  target.owners = $._toFrozenArray(
    initializer.owners || [],
    CrmOwnerOpportunityStats.create,
  );
}

// -----------------------------------------------------------------------------
// struct CrmDurationStats
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmDurationStats.Mutable`. */
export class CrmDurationStats extends $._FrozenBase {}

function initCrmDurationStats(target, initializer) {
  target.deals = initializer.deals ?? 0;
  target.meanDays = initializer.meanDays ?? null;
  target.medianDays = initializer.medianDays ?? null;
  target.p75Days = initializer.p75Days ?? null;
}

// -----------------------------------------------------------------------------
// struct CrmStageDuration
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmStageDuration.Mutable`. */
export class CrmStageDuration extends $._FrozenBase {}

function initCrmStageDuration(target, initializer) {
  target.pipelineId = initializer.pipelineId ?? "";
  target.stageName = initializer.stageName ?? "";
  target.displayOrder = initializer.displayOrder ?? null;
  target.duration = CrmDurationStats.create(initializer.duration ?? CrmDurationStats.DEFAULT);
  target.undatedStays = initializer.undatedStays ?? 0;
}

// -----------------------------------------------------------------------------
// struct CrmOwnerCycleStats
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmOwnerCycleStats.Mutable`. */
export class CrmOwnerCycleStats extends $._FrozenBase {}

function initCrmOwnerCycleStats(target, initializer) {
  target.ownerEmail = initializer.ownerEmail ?? "";
  target.won = CrmDurationStats.create(initializer.won ?? CrmDurationStats.DEFAULT);
  target.lost = CrmDurationStats.create(initializer.lost ?? CrmDurationStats.DEFAULT);
}

// -----------------------------------------------------------------------------
// struct CrmDealVelocity
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmDealVelocity.Mutable`. */
export class CrmDealVelocity extends $._FrozenBase {}

function initCrmDealVelocity(target, initializer) {
  target.startDate = initializer.startDate ?? "";
  target.endDate = initializer.endDate ?? "";
  target.asOf = initializer.asOf ?? "";
  target.wonCycle = CrmDurationStats.create(initializer.wonCycle ?? CrmDurationStats.DEFAULT);
  target.lostCycle = CrmDurationStats.create(initializer.lostCycle ?? CrmDurationStats.DEFAULT);
  target.unmeasuredClosedDeals = initializer.unmeasuredClosedDeals ?? 0;
  target.undatedClosedDeals = initializer.undatedClosedDeals ?? 0;
  target.owners = $._toFrozenArray(
    initializer.owners || [],
    CrmOwnerCycleStats.create,
  );
  target.stages = $._toFrozenArray(
    initializer.stages || [],
    CrmStageDuration.create,
  );
  target.historyStartsAt = initializer.historyStartsAt ?? "";
}

// -----------------------------------------------------------------------------
// struct CrmForecastAccuracy
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CrmForecastAccuracy.Mutable`. */
export class CrmForecastAccuracy extends $._FrozenBase {}

function initCrmForecastAccuracy(target, initializer) {
  target.periodStart = initializer.periodStart ?? "";
  target.periodEnd = initializer.periodEnd ?? "";
  target.asOf = initializer.asOf ?? "";
  target.forecastDeals = initializer.forecastDeals ?? 0;
  target.forecastValue = initializer.forecastValue ?? 0;
  target.forecastWeightedValue = initializer.forecastWeightedValue ?? 0;
  target.forecastDealsWithoutProbability = initializer.forecastDealsWithoutProbability ?? 0;
  target.wonDeals = initializer.wonDeals ?? 0;
  target.wonValue = initializer.wonValue ?? 0;
  target.lostDeals = initializer.lostDeals ?? 0;
  target.slippedDeals = initializer.slippedDeals ?? 0;
  target.slippedValue = initializer.slippedValue ?? 0;
  target.actualWonDeals = initializer.actualWonDeals ?? 0;
  target.actualWonValue = initializer.actualWonValue ?? 0;
  target.unforecastWonDeals = initializer.unforecastWonDeals ?? 0;
  target.unforecastWonValue = initializer.unforecastWonValue ?? 0;
  target.valueAccuracy = initializer.valueAccuracy ?? null;
  target.weightedAccuracy = initializer.weightedAccuracy ?? null;
  target.forecastWinRate = initializer.forecastWinRate ?? null;
  target.unknownDeals = initializer.unknownDeals ?? 0;
  target.historyStartsAt = initializer.historyStartsAt ?? "";
  target.currencies = $._toFrozenArray(
    initializer.currencies || []);
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "crm.skir",
  [
    {
      kind: "enum",
      ctor: CrmProvider,
      createValueFn: createValueOfCrmProvider,
      name: "CrmProvider",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "HUBSPOT",
          number: 1,
        },
        {
          name: "SALESFORCE",
          number: 2,
        },
        {
          name: "PIPEDRIVE",
          number: 3,
        },
        {
          name: "ATTIO",
          number: 4,
        },
        {
          name: "other",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: CrmSyncStatus,
      name: "CrmSyncStatus",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "CONNECTED",
          number: 1,
        },
        {
          name: "SYNCED",
          number: 2,
        },
        {
          name: "ERROR",
          number: 3,
        },
        {
          name: "DISCONNECTED",
          number: 4,
        },
        {
          name: "NEEDS_REAUTH",
          number: 5,
        },
      ],
    },
    {
      kind: "enum",
      ctor: DescriptionMode,
      name: "DescriptionMode",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "APPEND",
          number: 1,
        },
        {
          name: "OVERWRITE",
          number: 2,
        },
      ],
    },
    {
      kind: "enum",
      ctor: CustomFieldWriteMode,
      name: "CustomFieldWriteMode",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "REQUIRE_VALIDATION",
          number: 1,
        },
        {
          name: "AUTOMATIC",
          number: 2,
        },
      ],
    },
    {
      kind: "enum",
      ctor: CrmDataSource,
      createValueFn: createValueOfCrmDataSource,
      name: "CrmDataSource",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "MANUAL",
          number: 1,
        },
        {
          name: "EMAIL_DOMAIN",
          number: 2,
        },
        {
          name: "CRM_SYNC",
          number: 3,
        },
        {
          name: "other",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: CrmInferredFrom,
      createValueFn: createValueOfCrmInferredFrom,
      name: "CrmInferredFrom",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "MANUAL_CREATION",
          number: 1,
        },
        {
          name: "MEETING_CONTEXT",
          number: 2,
        },
        {
          name: "CRM_SYNC",
          number: 3,
        },
        {
          name: "DEMO_SETUP",
          number: 4,
        },
        {
          name: "other",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: CrmMatchingMethod,
      createValueFn: createValueOfCrmMatchingMethod,
      name: "CrmMatchingMethod",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "EMAIL_MATCH",
          number: 1,
        },
        {
          name: "CALENDAR_MATCH",
          number: 2,
        },
        {
          name: "MANUAL",
          number: 3,
        },
        {
          name: "other",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: CrmMatchAcceptanceMethod,
      createValueFn: createValueOfCrmMatchAcceptanceMethod,
      name: "CrmMatchAcceptanceMethod",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "AUTO",
          number: 1,
        },
        {
          name: "MANUAL",
          number: 2,
        },
        {
          name: "REJECTED",
          number: 3,
        },
        {
          name: "other",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmMergeConnection,
      initFn: initCrmMergeConnection,
      name: "CrmMergeConnection",
      fields: [
        {
          name: "account_token",
          property: "accountToken",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "provider_name",
          property: "providerName",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmHubspotConnection,
      initFn: initCrmHubspotConnection,
      name: "CrmHubspotConnection",
      fields: [
        {
          name: "portal_id",
          property: "portalId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "datacenter",
          property: "datacenter",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "access_token",
          property: "accessToken",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "refresh_token",
          property: "refreshToken",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmAttioConnection,
      initFn: initCrmAttioConnection,
      name: "CrmAttioConnection",
      fields: [
        {
          name: "access_token",
          property: "accessToken",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "workspace_slug",
          property: "workspaceSlug",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "webhook_id",
          property: "webhookId",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "webhook_secret",
          property: "webhookSecret",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmSalesforceConnection,
      initFn: initCrmSalesforceConnection,
      name: "CrmSalesforceConnection",
      fields: [
        {
          name: "access_token",
          property: "accessToken",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "refresh_token",
          property: "refreshToken",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "instance_url",
          property: "instanceUrl",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "org_id",
          property: "orgId",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: CrmConnection,
      createValueFn: createValueOfCrmConnection,
      name: "CrmConnection",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "merge",
          number: 1,
          type: {
            kind: "record",
            ctor: CrmMergeConnection,
          },
        },
        {
          name: "hubspot",
          number: 2,
          type: {
            kind: "record",
            ctor: CrmHubspotConnection,
          },
        },
        {
          name: "attio",
          number: 3,
          type: {
            kind: "record",
            ctor: CrmAttioConnection,
          },
        },
        {
          name: "salesforce",
          number: 4,
          type: {
            kind: "record",
            ctor: CrmSalesforceConnection,
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmEntity,
      initFn: initCrmEntity,
      name: "CrmEntity",
      fields: [
        {
          name: "remote_id",
          property: "remoteId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "merge_id",
          property: "mergeId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "last_sync",
          property: "lastSync",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "crm_provider",
          property: "crmProvider",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "provider_type",
          property: "providerType",
          number: 4,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CrmProvider,
            },
          },
        },
        {
          name: "deleted_at",
          property: "deletedAt",
          number: 5,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "web_url",
          property: "webUrl",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ExternalCrmAccount_Address,
      initFn: initExternalCrmAccount_Address,
      name: "Address",
      parentCtor: ExternalCrmAccount,
      fields: [
        {
          name: "street",
          property: "street",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "city",
          property: "city",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "state",
          property: "state",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "postal_code",
          property: "postalCode",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "country",
          property: "country",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ExternalCrmAccount,
      initFn: initExternalCrmAccount,
      name: "ExternalCrmAccount",
      fields: [
        {
          name: "base",
          property: "base",
          number: 0,
          type: {
            kind: "record",
            ctor: CrmEntity,
          },
          mutableGetter: "mutableBase",
        },
        {
          name: "name",
          property: "name",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description",
          property: "description",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "industry",
          property: "industry",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "website",
          property: "website",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "billing_address",
          property: "billingAddress",
          number: 5,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: ExternalCrmAccount_Address,
            },
          },
        },
        {
          name: "account_type",
          property: "accountType",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "annual_revenue",
          property: "annualRevenue",
          number: 7,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float64",
            },
          },
        },
        {
          name: "number_of_employees",
          property: "numberOfEmployees",
          number: 8,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int32",
            },
          },
        },
        {
          name: "owner_name",
          property: "ownerName",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_email",
          property: "ownerEmail",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ExternalCrmContact,
      initFn: initExternalCrmContact,
      name: "ExternalCrmContact",
      fields: [
        {
          name: "base",
          property: "base",
          number: 0,
          type: {
            kind: "record",
            ctor: CrmEntity,
          },
          mutableGetter: "mutableBase",
        },
        {
          name: "first_name",
          property: "firstName",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "last_name",
          property: "lastName",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "email",
          property: "email",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "phone",
          property: "phone",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "job_title",
          property: "jobTitle",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "account_id",
          property: "accountId",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "account_name",
          property: "accountName",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "lead_source",
          property: "leadSource",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "contact_stage",
          property: "contactStage",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "linkedin_url",
          property: "linkedinUrl",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "notes",
          property: "notes",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "last_activity_at",
          property: "lastActivityAt",
          number: 12,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "owner_name",
          property: "ownerName",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_email",
          property: "ownerEmail",
          number: 14,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: ExternalCrmEngagement_EngagementType,
      name: "EngagementType",
      parentCtor: ExternalCrmEngagement,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "EMAIL",
          number: 1,
        },
        {
          name: "CALL",
          number: 2,
        },
        {
          name: "MEETING",
          number: 3,
        },
        {
          name: "TASK",
          number: 4,
        },
        {
          name: "NOTE",
          number: 5,
        },
        {
          name: "OTHER",
          number: 6,
        },
      ],
    },
    {
      kind: "enum",
      ctor: ExternalCrmEngagement_Direction,
      name: "Direction",
      parentCtor: ExternalCrmEngagement,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "INBOUND",
          number: 1,
        },
        {
          name: "OUTBOUND",
          number: 2,
        },
      ],
    },
    {
      kind: "struct",
      ctor: ExternalCrmEngagement,
      initFn: initExternalCrmEngagement,
      name: "ExternalCrmEngagement",
      fields: [
        {
          name: "base",
          property: "base",
          number: 0,
          type: {
            kind: "record",
            ctor: CrmEntity,
          },
          mutableGetter: "mutableBase",
        },
        {
          name: "subject",
          property: "subject",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "content",
          property: "content",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "engagement_type",
          property: "engagementType",
          number: 3,
          type: {
            kind: "record",
            ctor: ExternalCrmEngagement_EngagementType,
          },
        },
        {
          name: "direction",
          property: "direction",
          number: 4,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: ExternalCrmEngagement_Direction,
            },
          },
        },
        {
          name: "start_time",
          property: "startTime",
          number: 5,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "end_time",
          property: "endTime",
          number: 6,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "account_id",
          property: "accountId",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "contact_ids",
          property: "contactIds",
          number: 8,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableContactIds",
        },
        {
          name: "owner_name",
          property: "ownerName",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_email",
          property: "ownerEmail",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "created_at",
          property: "createdAt",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "modified_at",
          property: "modifiedAt",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "matched_via_email",
          property: "matchedViaEmail",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ExternalCrmDealStage,
      initFn: initExternalCrmDealStage,
      name: "ExternalCrmDealStage",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "name",
          property: "name",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "display_order",
          property: "displayOrder",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "probability",
          property: "probability",
          number: 3,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float32",
            },
          },
        },
        {
          name: "is_closed_won",
          property: "isClosedWon",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "is_closed_lost",
          property: "isClosedLost",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ExternalCrmPipeline,
      initFn: initExternalCrmPipeline,
      name: "ExternalCrmPipeline",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "name",
          property: "name",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "stages",
          property: "stages",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: ExternalCrmDealStage,
            },
          },
          mutableGetter: "mutableStages",
        },
      ],
    },
    {
      kind: "enum",
      ctor: ExternalCrmOpportunity_Status,
      name: "Status",
      parentCtor: ExternalCrmOpportunity,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "OPEN",
          number: 1,
        },
        {
          name: "WON",
          number: 2,
        },
        {
          name: "LOST",
          number: 3,
        },
      ],
    },
    {
      kind: "struct",
      ctor: ExternalCrmOpportunity,
      initFn: initExternalCrmOpportunity,
      name: "ExternalCrmOpportunity",
      fields: [
        {
          name: "base",
          property: "base",
          number: 0,
          type: {
            kind: "record",
            ctor: CrmEntity,
          },
          mutableGetter: "mutableBase",
        },
        {
          name: "name",
          property: "name",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description",
          property: "description",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "amount",
          property: "amount",
          number: 3,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float64",
            },
          },
        },
        {
          name: "currency",
          property: "currency",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "stage",
          property: "stage",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "probability",
          property: "probability",
          number: 6,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float32",
            },
          },
        },
        {
          name: "expected_close_date",
          property: "expectedCloseDate",
          number: 7,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "created_date",
          property: "createdDate",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "account_id",
          property: "accountId",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "account_name",
          property: "accountName",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "primary_contact_id",
          property: "primaryContactId",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_name",
          property: "ownerName",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_email",
          property: "ownerEmail",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "lead_source",
          property: "leadSource",
          number: 14,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "next_action",
          property: "nextAction",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "next_action_date",
          property: "nextActionDate",
          number: 16,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "deal_type",
          property: "dealType",
          number: 17,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "status",
          property: "status",
          number: 18,
          type: {
            kind: "record",
            ctor: ExternalCrmOpportunity_Status,
          },
        },
        {
          name: "pipeline_id",
          property: "pipelineId",
          number: 19,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "contact_ids",
          property: "contactIds",
          number: 20,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableContactIds",
        },
        {
          name: "stage_id",
          property: "stageId",
          number: 21,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "closed_at",
          property: "closedAt",
          number: 22,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: MeetingCrmLink_LinkType,
      name: "LinkType",
      parentCtor: MeetingCrmLink,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "AUTOMATIC",
          number: 1,
        },
        {
          name: "MANUAL",
          number: 2,
        },
        {
          name: "SUGGESTED",
          number: 3,
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingCrmLink_MatchingCriteria,
      initFn: initMeetingCrmLink_MatchingCriteria,
      name: "MatchingCriteria",
      parentCtor: MeetingCrmLink,
      fields: [
        {
          name: "matched_by_email",
          property: "matchedByEmail",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "matched_by_calendar_title",
          property: "matchedByCalendarTitle",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "matched_by_participant_domain",
          property: "matchedByParticipantDomain",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "matched_by_existing_opportunity",
          property: "matchedByExistingOpportunity",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "custom_matching_rules",
          property: "customMatchingRules",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableCustomMatchingRules",
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingCrmLink,
      initFn: initMeetingCrmLink,
      name: "MeetingCrmLink",
      fields: [
        {
          name: "meeting_id",
          property: "meetingId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "user_id",
          property: "userId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "opportunity_ids",
          property: "opportunityIds",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableOpportunityIds",
        },
        {
          name: "contact_ids",
          property: "contactIds",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableContactIds",
        },
        {
          name: "account_ids",
          property: "accountIds",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableAccountIds",
        },
        {
          name: "link_type",
          property: "linkType",
          number: 5,
          type: {
            kind: "record",
            ctor: MeetingCrmLink_LinkType,
          },
        },
        {
          name: "confidence_score",
          property: "confidenceScore",
          number: 6,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float32",
            },
          },
        },
        {
          name: "matching_criteria",
          property: "matchingCriteria",
          number: 7,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: MeetingCrmLink_MatchingCriteria,
            },
          },
        },
        {
          name: "linked_at",
          property: "linkedAt",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "last_updated",
          property: "lastUpdated",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "linked_by_user_id",
          property: "linkedByUserId",
          number: 10,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "notes",
          property: "notes",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmIntegration_MatchingPreferences,
      initFn: initCrmIntegration_MatchingPreferences,
      name: "MatchingPreferences",
      parentCtor: CrmIntegration,
      fields: [
        {
          name: "match_by_email",
          property: "matchByEmail",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "match_by_domain",
          property: "matchByDomain",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "match_by_calendar_keywords",
          property: "matchByCalendarKeywords",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "minimum_confidence_threshold",
          property: "minimumConfidenceThreshold",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "float32",
          },
        },
        {
          name: "auto_link_high_confidence",
          property: "autoLinkHighConfidence",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmIntegration_CrmSyncSettings_ContactSettings,
      initFn: initCrmIntegration_CrmSyncSettings_ContactSettings,
      name: "ContactSettings",
      parentCtor: CrmIntegration_CrmSyncSettings,
      fields: [
        {
          name: "enabled",
          property: "enabled",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "auto_create",
          property: "autoCreate",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "create_call_note",
          property: "createCallNote",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "sync_last_contacted",
          property: "syncLastContacted",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmIntegration_CrmSyncSettings_AccountSettings,
      initFn: initCrmIntegration_CrmSyncSettings_AccountSettings,
      name: "AccountSettings",
      parentCtor: CrmIntegration_CrmSyncSettings,
      fields: [
        {
          name: "enabled",
          property: "enabled",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "auto_create",
          property: "autoCreate",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "sync_description",
          property: "syncDescription",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "sync_last_interaction",
          property: "syncLastInteraction",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "description_mode",
          property: "descriptionMode",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description_mode_type",
          property: "descriptionModeType",
          number: 5,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: DescriptionMode,
            },
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmIntegration_CrmSyncSettings_CustomFieldSyncSetting,
      initFn: initCrmIntegration_CrmSyncSettings_CustomFieldSyncSetting,
      name: "CustomFieldSyncSetting",
      parentCtor: CrmIntegration_CrmSyncSettings,
      fields: [
        {
          name: "api_slug",
          property: "apiSlug",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "enabled",
          property: "enabled",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "mode",
          property: "mode",
          number: 2,
          type: {
            kind: "record",
            ctor: CustomFieldWriteMode,
          },
        },
        {
          name: "instructions",
          property: "instructions",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmIntegration_CrmSyncSettings,
      initFn: initCrmIntegration_CrmSyncSettings,
      name: "CrmSyncSettings",
      parentCtor: CrmIntegration,
      fields: [
        {
          name: "contacts",
          property: "contacts",
          number: 0,
          type: {
            kind: "record",
            ctor: CrmIntegration_CrmSyncSettings_ContactSettings,
          },
          mutableGetter: "mutableContacts",
        },
        {
          name: "accounts",
          property: "accounts",
          number: 1,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CrmIntegration_CrmSyncSettings_AccountSettings,
            },
          },
        },
        {
          name: "opportunity_custom_fields",
          property: "opportunityCustomFields",
          number: 2,
          type: {
            kind: "optional",
            other: {
              kind: "array",
              item: {
                kind: "record",
                ctor: CrmIntegration_CrmSyncSettings_CustomFieldSyncSetting,
              },
            },
          },
        },
        {
          name: "contact_custom_fields",
          property: "contactCustomFields",
          number: 3,
          type: {
            kind: "optional",
            other: {
              kind: "array",
              item: {
                kind: "record",
                ctor: CrmIntegration_CrmSyncSettings_CustomFieldSyncSetting,
              },
            },
          },
        },
        {
          name: "account_custom_fields",
          property: "accountCustomFields",
          number: 4,
          type: {
            kind: "optional",
            other: {
              kind: "array",
              item: {
                kind: "record",
                ctor: CrmIntegration_CrmSyncSettings_CustomFieldSyncSetting,
              },
            },
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmIntegration,
      initFn: initCrmIntegration,
      name: "CrmIntegration",
      fields: [
        {
          name: "account_id",
          property: "accountId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "oauth_state",
          property: "oauthState",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "merge_account_token",
          property: "mergeAccountToken",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "oauth_connected_at",
          property: "oauthConnectedAt",
          number: 3,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "oauth_expires_at",
          property: "oauthExpiresAt",
          number: 4,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "crm_provider",
          property: "crmProvider",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "crm_instance_url",
          property: "crmInstanceUrl",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "crm_user_email",
          property: "crmUserEmail",
          number: 7,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "auto_matching_enabled",
          property: "autoMatchingEnabled",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "sync_frequency_hours",
          property: "syncFrequencyHours",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "last_sync",
          property: "lastSync",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "sync_status",
          property: "syncStatus",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "sync_error_message",
          property: "syncErrorMessage",
          number: 12,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "matching_preferences",
          property: "matchingPreferences",
          number: 13,
          type: {
            kind: "record",
            ctor: CrmIntegration_MatchingPreferences,
          },
          mutableGetter: "mutableMatchingPreferences",
        },
        {
          name: "enabled_at",
          property: "enabledAt",
          number: 14,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "enabled_by_user_id",
          property: "enabledByUserId",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "hubspot_portal_id",
          property: "hubspotPortalId",
          number: 16,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "hubspot_datacenter",
          property: "hubspotDatacenter",
          number: 17,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "sync_settings",
          property: "syncSettings",
          number: 18,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CrmIntegration_CrmSyncSettings,
            },
          },
        },
        {
          name: "connector_type",
          property: "connectorType",
          number: 19,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "hubspot_access_token",
          property: "hubspotAccessToken",
          number: 20,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "hubspot_refresh_token",
          property: "hubspotRefreshToken",
          number: 21,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "attio_access_token",
          property: "attioAccessToken",
          number: 22,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "attio_workspace_slug",
          property: "attioWorkspaceSlug",
          number: 23,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "salesforce_access_token",
          property: "salesforceAccessToken",
          number: 24,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "salesforce_refresh_token",
          property: "salesforceRefreshToken",
          number: 25,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "salesforce_instance_url",
          property: "salesforceInstanceUrl",
          number: 26,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "salesforce_org_id",
          property: "salesforceOrgId",
          number: 27,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "attio_webhook_id",
          property: "attioWebhookId",
          number: 28,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "attio_webhook_secret",
          property: "attioWebhookSecret",
          number: 29,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "connection",
          property: "connection",
          number: 30,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CrmConnection,
            },
          },
        },
        {
          name: "sync_status_type",
          property: "syncStatusType",
          number: 31,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CrmSyncStatus,
            },
          },
        },
        {
          name: "crm_write_access",
          property: "crmWriteAccess",
          number: 32,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "bool",
            },
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmMatchingLog,
      initFn: initCrmMatchingLog,
      name: "CrmMatchingLog",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "meeting_id",
          property: "meetingId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "user_id",
          property: "userId",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "account_id",
          property: "accountId",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "attempted_at",
          property: "attemptedAt",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "matching_method",
          property: "matchingMethod",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "opportunities_found",
          property: "opportunitiesFound",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "contacts_found",
          property: "contactsFound",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "accounts_found",
          property: "accountsFound",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "best_match_opportunity_id",
          property: "bestMatchOpportunityId",
          number: 9,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "best_match_confidence",
          property: "bestMatchConfidence",
          number: 10,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float32",
            },
          },
        },
        {
          name: "criteria_used",
          property: "criteriaUsed",
          number: 11,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableCriteriaUsed",
        },
        {
          name: "match_accepted",
          property: "matchAccepted",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "match_acceptance_method",
          property: "matchAcceptanceMethod",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "error_message",
          property: "errorMessage",
          number: 14,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "matching_duration_ms",
          property: "matchingDurationMs",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "matching_method_type",
          property: "matchingMethodType",
          number: 16,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CrmMatchingMethod,
            },
          },
        },
        {
          name: "match_acceptance_method_type",
          property: "matchAcceptanceMethodType",
          number: 17,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CrmMatchAcceptanceMethod,
            },
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmDataCache,
      initFn: initCrmDataCache,
      name: "CrmDataCache",
      fields: [
        {
          name: "account_id",
          property: "accountId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "opportunities",
          property: "opportunities",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: ExternalCrmOpportunity,
            },
          },
          mutableGetter: "mutableOpportunities",
        },
        {
          name: "contacts",
          property: "contacts",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: ExternalCrmContact,
            },
          },
          mutableGetter: "mutableContacts",
        },
        {
          name: "accounts",
          property: "accounts",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: ExternalCrmAccount,
            },
          },
          mutableGetter: "mutableAccounts",
        },
        {
          name: "last_updated",
          property: "lastUpdated",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "cache_version",
          property: "cacheVersion",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "total_opportunities",
          property: "totalOpportunities",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "total_contacts",
          property: "totalContacts",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "total_accounts",
          property: "totalAccounts",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "enum",
      ctor: CrmAccount_AccountType,
      name: "AccountType",
      parentCtor: CrmAccount,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "PROSPECT",
          number: 1,
        },
        {
          name: "CUSTOMER",
          number: 2,
        },
        {
          name: "PARTNER",
          number: 3,
        },
        {
          name: "INTERNAL",
          number: 4,
        },
        {
          name: "UNCLASSIFIED",
          number: 5,
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmAccount,
      initFn: initCrmAccount,
      name: "CrmAccount",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int64",
            },
          },
        },
        {
          name: "account_id",
          property: "accountId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "name",
          property: "name",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "domain",
          property: "domain",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "additional_domains",
          property: "additionalDomains",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableAdditionalDomains",
        },
        {
          name: "industry",
          property: "industry",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description",
          property: "description",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "website",
          property: "website",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "total_contacts",
          property: "totalContacts",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "total_meetings",
          property: "totalMeetings",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "first_interaction",
          property: "firstInteraction",
          number: 13,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "last_interaction",
          property: "lastInteraction",
          number: 14,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "account_type",
          property: "accountType",
          number: 15,
          type: {
            kind: "record",
            ctor: CrmAccount_AccountType,
          },
        },
        {
          name: "created_at",
          property: "createdAt",
          number: 16,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "updated_at",
          property: "updatedAt",
          number: 17,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "confidence_score",
          property: "confidenceScore",
          number: 18,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "data_source",
          property: "dataSource",
          number: 19,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "external_crm",
          property: "externalCrm",
          number: 20,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CrmEntity,
            },
          },
        },
        {
          name: "external_crm_permalink",
          property: "externalCrmPermalink",
          number: 21,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "owner_name",
          property: "ownerName",
          number: 22,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_email",
          property: "ownerEmail",
          number: 23,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_user_id",
          property: "ownerUserId",
          number: 24,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "data_source_type",
          property: "dataSourceType",
          number: 25,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CrmDataSource,
            },
          },
        },
      ],
      removedNumbers: [
        10,
        8,
        9,
      ],
    },
    {
      kind: "enum",
      ctor: CrmOpportunity_Stage,
      name: "Stage",
      parentCtor: CrmOpportunity,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "DISCOVERY",
          number: 1,
        },
        {
          name: "QUALIFICATION",
          number: 2,
        },
        {
          name: "PROPOSAL",
          number: 3,
        },
        {
          name: "NEGOTIATION",
          number: 4,
        },
        {
          name: "CLOSED_WON",
          number: 5,
        },
        {
          name: "CLOSED_LOST",
          number: 6,
        },
        {
          name: "ON_HOLD",
          number: 7,
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmOpportunity,
      initFn: initCrmOpportunity,
      name: "CrmOpportunity",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int64",
            },
          },
        },
        {
          name: "account_id",
          property: "accountId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
        {
          name: "name",
          property: "name",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description",
          property: "description",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "crm_account_id",
          property: "crmAccountId",
          number: 4,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int64",
            },
          },
        },
        {
          name: "account_name",
          property: "accountName",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "primary_contact_ids",
          property: "primaryContactIds",
          number: 6,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "int64",
            },
          },
          mutableGetter: "mutablePrimaryContactIds",
        },
        {
          name: "estimated_value",
          property: "estimatedValue",
          number: 7,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float64",
            },
          },
        },
        {
          name: "currency",
          property: "currency",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "stage",
          property: "stage",
          number: 9,
          type: {
            kind: "record",
            ctor: CrmOpportunity_Stage,
          },
        },
        {
          name: "expected_close_date",
          property: "expectedCloseDate",
          number: 10,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "probability",
          property: "probability",
          number: 11,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float32",
            },
          },
        },
        {
          name: "total_meetings",
          property: "totalMeetings",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "last_meeting_date",
          property: "lastMeetingDate",
          number: 16,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "created_at",
          property: "createdAt",
          number: 17,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "updated_at",
          property: "updatedAt",
          number: 18,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "confidence_score",
          property: "confidenceScore",
          number: 19,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "inferred_from",
          property: "inferredFrom",
          number: 20,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "external_crm",
          property: "externalCrm",
          number: 21,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CrmEntity,
            },
          },
        },
        {
          name: "external_crm_permalink",
          property: "externalCrmPermalink",
          number: 22,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "stage_name",
          property: "stageName",
          number: 23,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "pipeline_id",
          property: "pipelineId",
          number: 24,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "stage_id",
          property: "stageId",
          number: 25,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "stage_display_order",
          property: "stageDisplayOrder",
          number: 26,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "stage_is_closed",
          property: "stageIsClosed",
          number: 27,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "account_domain",
          property: "accountDomain",
          number: 28,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "stage_is_closed_won",
          property: "stageIsClosedWon",
          number: 29,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "stage_is_closed_lost",
          property: "stageIsClosedLost",
          number: 30,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "owner_name",
          property: "ownerName",
          number: 31,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_email",
          property: "ownerEmail",
          number: 32,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_user_id",
          property: "ownerUserId",
          number: 33,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "inferred_from_type",
          property: "inferredFromType",
          number: 34,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CrmInferredFrom,
            },
          },
        },
        {
          name: "closed_at",
          property: "closedAt",
          number: 35,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
      ],
      removedNumbers: [
        12,
        13,
        14,
      ],
    },
    {
      kind: "enum",
      ctor: CrmOpportunityStatus,
      name: "CrmOpportunityStatus",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "OPEN",
          number: 1,
        },
        {
          name: "WON",
          number: 2,
        },
        {
          name: "LOST",
          number: 3,
        },
      ],
    },
    {
      kind: "struct",
      ctor: TimeRange,
      initFn: initTimeRange,
      name: "TimeRange",
      fields: [
        {
          name: "start",
          property: "start",
          number: 0,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "end",
          property: "end",
          number: 1,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmOpportunityFilter,
      initFn: initCrmOpportunityFilter,
      name: "CrmOpportunityFilter",
      fields: [
        {
          name: "search_query",
          property: "searchQuery_",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "pipeline_ids",
          property: "pipelineIds",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutablePipelineIds",
        },
        {
          name: "excluded_pipeline_ids",
          property: "excludedPipelineIds",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableExcludedPipelineIds",
        },
        {
          name: "stage_ids",
          property: "stageIds",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableStageIds",
        },
        {
          name: "stages",
          property: "stages",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CrmOpportunity_Stage,
            },
          },
          mutableGetter: "mutableStages",
        },
        {
          name: "statuses",
          property: "statuses",
          number: 5,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CrmOpportunityStatus,
            },
          },
          mutableGetter: "mutableStatuses",
        },
        {
          name: "owner_emails",
          property: "ownerEmails",
          number: 6,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableOwnerEmails",
        },
        {
          name: "owner_user_ids",
          property: "ownerUserIds",
          number: 7,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableOwnerUserIds",
        },
        {
          name: "expected_close",
          property: "expectedClose",
          number: 8,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: TimeRange,
            },
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmOpportunityFacets_StatusCount,
      initFn: initCrmOpportunityFacets_StatusCount,
      name: "StatusCount",
      parentCtor: CrmOpportunityFacets,
      fields: [
        {
          name: "status",
          property: "status",
          number: 0,
          type: {
            kind: "record",
            ctor: CrmOpportunityStatus,
          },
        },
        {
          name: "count",
          property: "count",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmOpportunityFacets_PipelineCount,
      initFn: initCrmOpportunityFacets_PipelineCount,
      name: "PipelineCount",
      parentCtor: CrmOpportunityFacets,
      fields: [
        {
          name: "pipeline_id",
          property: "pipelineId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "count",
          property: "count",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmOpportunityFacets_StageCount,
      initFn: initCrmOpportunityFacets_StageCount,
      name: "StageCount",
      parentCtor: CrmOpportunityFacets,
      fields: [
        {
          name: "pipeline_id",
          property: "pipelineId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "stage_id",
          property: "stageId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "stage",
          property: "stage",
          number: 2,
          type: {
            kind: "record",
            ctor: CrmOpportunity_Stage,
          },
        },
        {
          name: "stage_name",
          property: "stageName",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "display_order",
          property: "displayOrder",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "status",
          property: "status",
          number: 5,
          type: {
            kind: "record",
            ctor: CrmOpportunityStatus,
          },
        },
        {
          name: "count",
          property: "count",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmOpportunityFacets_OwnerCount,
      initFn: initCrmOpportunityFacets_OwnerCount,
      name: "OwnerCount",
      parentCtor: CrmOpportunityFacets,
      fields: [
        {
          name: "owner_email",
          property: "ownerEmail",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_name",
          property: "ownerName",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "owner_user_id",
          property: "ownerUserId",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "count",
          property: "count",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmOpportunityFacets,
      initFn: initCrmOpportunityFacets,
      name: "CrmOpportunityFacets",
      fields: [
        {
          name: "total_count",
          property: "totalCount",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "statuses",
          property: "statuses",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CrmOpportunityFacets_StatusCount,
            },
          },
          mutableGetter: "mutableStatuses",
        },
        {
          name: "pipelines",
          property: "pipelines",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CrmOpportunityFacets_PipelineCount,
            },
          },
          mutableGetter: "mutablePipelines",
        },
        {
          name: "stages",
          property: "stages",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CrmOpportunityFacets_StageCount,
            },
          },
          mutableGetter: "mutableStages",
        },
        {
          name: "owners",
          property: "owners",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CrmOpportunityFacets_OwnerCount,
            },
          },
          mutableGetter: "mutableOwners",
        },
      ],
    },
    {
      kind: "enum",
      ctor: CrmObjectType,
      name: "CrmObjectType",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "CONTACT",
          number: 1,
        },
        {
          name: "ACCOUNT",
          number: 2,
        },
        {
          name: "OPPORTUNITY",
          number: 3,
        },
      ],
    },
    {
      kind: "struct",
      ctor: ExternalCrmField,
      initFn: initExternalCrmField,
      name: "ExternalCrmField",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "api_slug",
          property: "apiSlug",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "name",
          property: "name",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "type",
          property: "type",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "is_writable",
          property: "isWritable",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "description",
          property: "description",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "choices",
          property: "choices",
          number: 6,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableChoices",
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmOpportunityWindowStats,
      initFn: initCrmOpportunityWindowStats,
      name: "CrmOpportunityWindowStats",
      fields: [
        {
          name: "start_date",
          property: "startDate",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "end_date",
          property: "endDate",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "created",
          property: "created",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "created_value",
          property: "createdValue",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "won",
          property: "won",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "lost",
          property: "lost",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "open",
          property: "open",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmOwnerOpportunityStats,
      initFn: initCrmOwnerOpportunityStats,
      name: "CrmOwnerOpportunityStats",
      fields: [
        {
          name: "owner_email",
          property: "ownerEmail",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "created",
          property: "created",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "won",
          property: "won",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "lost",
          property: "lost",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "open",
          property: "open",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmPipelineAnalytics,
      initFn: initCrmPipelineAnalytics,
      name: "CrmPipelineAnalytics",
      fields: [
        {
          name: "start_date",
          property: "startDate",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "end_date",
          property: "endDate",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "as_of",
          property: "asOf",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "total_deals",
          property: "totalDeals",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "open_deals",
          property: "openDeals",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "won_deals",
          property: "wonDeals",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "lost_deals",
          property: "lostDeals",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "open_value",
          property: "openValue",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "won_value",
          property: "wonValue",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "close_rate",
          property: "closeRate",
          number: 9,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float64",
            },
          },
        },
        {
          name: "window",
          property: "window",
          number: 10,
          type: {
            kind: "record",
            ctor: CrmOpportunityWindowStats,
          },
          mutableGetter: "mutableWindow",
        },
        {
          name: "owners",
          property: "owners",
          number: 11,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CrmOwnerOpportunityStats,
            },
          },
          mutableGetter: "mutableOwners",
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmDurationStats,
      initFn: initCrmDurationStats,
      name: "CrmDurationStats",
      fields: [
        {
          name: "deals",
          property: "deals",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "mean_days",
          property: "meanDays",
          number: 1,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float64",
            },
          },
        },
        {
          name: "median_days",
          property: "medianDays",
          number: 2,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float64",
            },
          },
        },
        {
          name: "p75_days",
          property: "p75Days",
          number: 3,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float64",
            },
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmStageDuration,
      initFn: initCrmStageDuration,
      name: "CrmStageDuration",
      fields: [
        {
          name: "pipeline_id",
          property: "pipelineId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "stage_name",
          property: "stageName",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "display_order",
          property: "displayOrder",
          number: 2,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int32",
            },
          },
        },
        {
          name: "duration",
          property: "duration",
          number: 3,
          type: {
            kind: "record",
            ctor: CrmDurationStats,
          },
          mutableGetter: "mutableDuration",
        },
        {
          name: "undated_stays",
          property: "undatedStays",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmOwnerCycleStats,
      initFn: initCrmOwnerCycleStats,
      name: "CrmOwnerCycleStats",
      fields: [
        {
          name: "owner_email",
          property: "ownerEmail",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "won",
          property: "won",
          number: 1,
          type: {
            kind: "record",
            ctor: CrmDurationStats,
          },
          mutableGetter: "mutableWon",
        },
        {
          name: "lost",
          property: "lost",
          number: 2,
          type: {
            kind: "record",
            ctor: CrmDurationStats,
          },
          mutableGetter: "mutableLost",
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmDealVelocity,
      initFn: initCrmDealVelocity,
      name: "CrmDealVelocity",
      fields: [
        {
          name: "start_date",
          property: "startDate",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "end_date",
          property: "endDate",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "as_of",
          property: "asOf",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "won_cycle",
          property: "wonCycle",
          number: 3,
          type: {
            kind: "record",
            ctor: CrmDurationStats,
          },
          mutableGetter: "mutableWonCycle",
        },
        {
          name: "lost_cycle",
          property: "lostCycle",
          number: 4,
          type: {
            kind: "record",
            ctor: CrmDurationStats,
          },
          mutableGetter: "mutableLostCycle",
        },
        {
          name: "unmeasured_closed_deals",
          property: "unmeasuredClosedDeals",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "undated_closed_deals",
          property: "undatedClosedDeals",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "owners",
          property: "owners",
          number: 7,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CrmOwnerCycleStats,
            },
          },
          mutableGetter: "mutableOwners",
        },
        {
          name: "stages",
          property: "stages",
          number: 8,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CrmStageDuration,
            },
          },
          mutableGetter: "mutableStages",
        },
        {
          name: "history_starts_at",
          property: "historyStartsAt",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CrmForecastAccuracy,
      initFn: initCrmForecastAccuracy,
      name: "CrmForecastAccuracy",
      fields: [
        {
          name: "period_start",
          property: "periodStart",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "period_end",
          property: "periodEnd",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "as_of",
          property: "asOf",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "forecast_deals",
          property: "forecastDeals",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "forecast_value",
          property: "forecastValue",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "forecast_weighted_value",
          property: "forecastWeightedValue",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "forecast_deals_without_probability",
          property: "forecastDealsWithoutProbability",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "won_deals",
          property: "wonDeals",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "won_value",
          property: "wonValue",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "lost_deals",
          property: "lostDeals",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "slipped_deals",
          property: "slippedDeals",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "slipped_value",
          property: "slippedValue",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "actual_won_deals",
          property: "actualWonDeals",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "actual_won_value",
          property: "actualWonValue",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "unforecast_won_deals",
          property: "unforecastWonDeals",
          number: 14,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "unforecast_won_value",
          property: "unforecastWonValue",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "value_accuracy",
          property: "valueAccuracy",
          number: 16,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float64",
            },
          },
        },
        {
          name: "weighted_accuracy",
          property: "weightedAccuracy",
          number: 17,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float64",
            },
          },
        },
        {
          name: "forecast_win_rate",
          property: "forecastWinRate",
          number: 18,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float64",
            },
          },
        },
        {
          name: "unknown_deals",
          property: "unknownDeals",
          number: 19,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "history_starts_at",
          property: "historyStartsAt",
          number: 20,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "currencies",
          property: "currencies",
          number: 21,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableCurrencies",
        },
      ],
    },
  ]
);
